(function () {
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-nn-quick-add]');
    if (!form) return;
    event.preventDefault();

    const btn = form.querySelector('[data-nn-add-button]');
    const label = form.querySelector('[data-nn-add-label]');
    const variantId = form.querySelector('input[name="id"]').value;
    const qty = Number(form.querySelector('input[name="quantity"]').value) || 1;

    if (btn) btn.classList.add('is-loading');
    if (btn) btn.disabled = true;
    const prevLabel = label ? label.textContent : '';
    if (label) label.textContent = 'Adding…';

    try {
      await window.NettyNature.cart.addItem(variantId, qty);
      if (label) label.textContent = 'Added';
      setTimeout(() => {
        if (label) label.textContent = prevLabel;
        if (btn) btn.classList.remove('is-loading');
        if (btn) btn.disabled = false;
      }, 1200);
    } catch (err) {
      if (label) label.textContent = 'Sold out';
      if (btn) btn.classList.remove('is-loading');
      setTimeout(() => {
        if (label) label.textContent = prevLabel;
        if (btn) btn.disabled = false;
      }, 1600);
    }
  });
})();
